<template>
    <b-overlay :show="showOverlay" rounded="sm" :style="customColor">
        <ReportsDialog ref="reportsDialog" :order-id="order.id" :statement-type="STATEMENT_TYPES[statementType]" :title="statementType == 0 ? 'Generate Invoice' : 'Generate Statement'
            " />
        <b-card-body class="px-0 form-sample" :style="customColor">
            <div class="d-flex title-bar-block">
                <div class="icon-block me-4">
                    <button  id="cancel-label-btn" v-b-tooltip.hover title="Back" @click="cancel()">
                        <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="text">
                    <span class="me-2"> {{ $translate('view_service_request') }}</span>
                </div>
            </div>
            <div class="accordion mt-3">
                <b-card no-body class="accordion-box" :style="customColor">
                    <div>
                        <a id="summary-accordion-tab" class="accordion-header" :class="{
                            'active-accordion':
                                activeAccordion === 'summary',
                        }" @click="activateAccordion('summary')">{{ $translate('summary') }}</a>
                    </div>
                    <b-collapse :visible="activeAccordion === 'summary'" class="accordion-content">
                        <CreateServiceRequest :item="order" />
                    </b-collapse>
                </b-card>
                <b-card no-body class="accordion-box" :style="customColor">
                    <div>
                        <a id="message-accordion-tab" class="accordion-header" :class="{
                            'active-accordion':
                                activeAccordion === 'messages',
                        }" @click="activateAccordion('messages')">{{ $translate('messages') }}</a>
                    </div>
                    <b-collapse :visible="activeAccordion === 'messages'" class="accordion-content">
                        <ServiceNotes :order="order" />
                    </b-collapse>
                </b-card>
                <b-card no-body class="accordion-box" :style="customColor">
                    <div>
                        <a id="attachment-accordion-tab" class="accordion-header" :class="{
                            'active-accordion':
                                activeAccordion === 'attachments',
                        }" @click="activateAccordion('attachments')">{{ $translate('attachments') }}</a>
                    </div>
                    <b-collapse :visible="activeAccordion === 'attachments'" class="accordion-content">
                        <ServiceAttachments :order="order" />
                    </b-collapse>
                </b-card>

                <b-card no-body class="accordion-box inner-accordian" :style="customColor">
                    <div>
                        <a id="details-accordion-tab" class="accordion-header" :class="{
                            'active-accordion':
                                activeAccordion === 'details',
                        }" @click="activateAccordion('details')">{{ $translate('details') }}</a>
                    </div>
                    <b-collapse :visible="activeAccordion === 'details'" class="accordion-content">
                        <service-request-items :order="order" />
                    </b-collapse>
                </b-card>
                <b-card no-body class="accordion-box inner-accordian" :style="customColor">
                    <div>
                        <a  id="rating-accordion-tab" class="accordion-header" :class="{
                            'active-accordion':
                                activeAccordion === 'ratings',
                        }" @click="activateAccordion('ratings')">{{ $translate('ratings') }}</a>
                    </div>
                    <b-collapse :visible="activeAccordion === 'ratings'" class="accordion-content">
                        <div>
                            <b-col>
                                <label for="input-reference-no" class="mb-3">
                                    <strong>{{ $translate('reference_no') }}</strong>
                                </label>
                                <b-form-input id="input-reference-no" v-model="serviceRequest.reference_no" type="text"
                                    required v-custom-validation="$textRequired()" disabled></b-form-input>
                            </b-col>
                            <b-col class="mt-3">
                                <label for="group-feedback" class="mb-3">
                                    <strong>{{ $translate('feedback') }}</strong>
                                </label>
                                <b-form-rating body-class="p-0 text-left" id="input-feedback"
                                    v-model="serviceRequest.feedback" :disabled="!editMode">
                                </b-form-rating>
                            </b-col>
                            <b-col class="mt-3">
                                <label for="input-feedback-comments" class="mb-3"><strong>{{ $translate('feedback_comments')
                                }}</strong></label>
                                <b-form-textarea id="input-description" v-model="serviceRequest.feedback_comments"
                                    :placeholder="$translate('enter_your_feedback')" rows="3" max-rows="4"
                                    :disabled="!editMode"></b-form-textarea>
                            </b-col>
                            <b-col class="mt-3">
                                <b-button-group v-if="!editMode">
                                    <b-button id="add-edit-rating-btn" size="fw" class="my-2" @click="editMode = !editMode" variant="info">
                                        {{ addRating ? $translate('add_rating') : $translate('edit_rating') }}
                                    </b-button>
                                </b-button-group>
                                <b-button-group size="sm" v-else-if="editMode">
                                    <b-button id="save-form-btn" size="fw" class="me-2" @click="onSubmit" variant="info">
                                        {{ $translate('save_changes') }}
                                    </b-button>
                                    <!-- <b-button size="fw" class="" @click="editMode = !editMode" variant="info"> -->
                                    <b-button id="cancel-form-btn" size="fw" class="" @click="cancelRating()" variant="info">
                                        {{ $cancelLabel() }}
                                    </b-button>
                                </b-button-group>
                            </b-col>
                        </div>
                    </b-collapse>
                </b-card>
                <b-card no-body class="accordion-box" :style="customColor">
                    <div>
                        <a id="documents-accordion-tab" class="accordion-header" :class="{
                            'active-accordion':
                                activeAccordion === 'documents',
                        }" @click="activateAccordion('documents')">{{ $translate('documents') }}</a>
                    </div>
                    <b-collapse :visible="activeAccordion === 'documents'" class="accordion-content">
                        <b-container fluid class="p-4">
                            <template v-if="order.items && order.items.length">
                                <b-button id="download-invoice-btn" class="ma-2" @click="triggerReport(0)" button variant="success">
                                    {{ $translate('download_invoice') }}
                                    <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                                </b-button>
                                <b-button id="download-statement-btn" class="ma-2" @click="triggerReport(1)" button variant="secondary">
                                    {{ $translate('download_statement') }}
                                    <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                                </b-button>
                            </template>
                            <p class="my-3" v-else>
                                {{ $translate('no_item_entered') }}
                            </p>
                        </b-container>
                    </b-collapse>
                </b-card>
            </div>
        </b-card-body>
    </b-overlay>
</template>
<script>
import { STATEMENT_TYPES } from '@/exports/jsreport_templates'
import popupMixins from '@/mixins/popupMixins'
import ReportsDialog from '@/components/ReportsDialog'

import ServiceAttachments from './ServiceAttachments'
import ServiceNotes from './ServiceNotes'
import CreateServiceRequest from './CreateServiceRequest.vue'
import ServiceRequestItems from './ServiceRequestItems.vue'

export default {
    name: 'CustomerPortalViewService',
    components: {
        ServiceAttachments,
        ServiceNotes,
        CreateServiceRequest,
        ServiceRequestItems,
        ReportsDialog,
    },
    mixins: [popupMixins],
    data() {
        return {
            activeAccordion: 'summary',
            STATEMENT_TYPES,
            statementType: 0,
            serviceRequest: {},
            loading: false,
            editMode: false,

        }
    },
    filters: {
        filterDate(date) {
            if (!date) return ''
            return date.split(' ')[0]
        },
        mapOptions(arr, isUser) {
            return arr.map(x => ({
                value: x.id,
                text: isUser ? `${x.first_name} ${x.last_name}` : (x.customer_portal_name || x.name),
            }))
        },
        filterSection(section) {
            if (!section) return ''
            const { name, location } = section || {}
            const { address1, address2, city } = location || {}
            return `${name}<br/>${address1}<br/>${address2}<br/>${city}`
        },
        filterTime(date) {
            if (!date) return ''
            return date.split(' ')[1]
        },
        filterOfficerName(officer) {
            if (!officer) return ''
            return officer.first_name + ' ' + officer.last_name
        },
        filterPrice(items) {
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            })
            const sum = (items || []).reduce((sum, item) => {
                sum +=
                    parseFloat(item.quantity) *
                    parseFloat(item.price) *
                    (1 + parseFloat(item.tax_rate) / 100)
                return sum
            }, 0)
            if (!sum) return '-'
            return formatter.format(sum)
        },
    },
    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'reference_no', label: this.$translate('reference_no') },
                {
                    key: 'feedback',
                    label: this.$translate('rating'),
                    formatter: (key, value, item) =>
                        item ? item.feedback : 10,
                },
                { key: 'feedback_comments', label: this.$translate('comments') },
                {
                    key: 'driver_id',
                    label: this.$translate('officer'),
                    formatter: (value, key, item) => {
                        const { first_name, last_name } = item.driver || {}
                        return `${first_name || ''} ${last_name || ''}`
                    },
                },
                {
                    key: 'completed',
                    label: this.$translate('status'),
                    formatter: (value, key, item) => {
                        return item.completed ? this.$translate('completed') : this.$translate('in_progress')
                    },
                },
            ]
        },
        customColor() {
            const data = this.$store.state.company.settings || {}
            const colors = {
                'background-color': data.background_color + '!important',
                color: data.text_color + '!important',
            }
            return colors
        },
        orderTypeName() {
            return (
                (this.order &&
                    this.order.type &&
                    (this.order.type.customer_portal_name ||
                        this.order.type.name)) ||
                ''
            )
        },

        driver() {
            const { first_name, last_name } = this.order || {}
            return `${first_name || ''} ${last_name || ''}`
        },

        drivers() {
            return this.$store.state.orders.drivers
        },
        showOverlay() {
            return this.$store.state.customerPortal.loading
        },
        order() {
            const computedOrder =
                this.$store.state.customerPortal.selectedOrder || {}
            return computedOrder
        },
        hasRating() {
            return !this.$store.state.customerPortal.selectedOrder.feedback
        },
        addRating() {
            return !(
                this.$store.state.customerPortal.selectedOrder.feedback
            )
        },
    },
    watch: {
        order: {
            immediate: true,
            handler(newOrder) {
                this.serviceRequest = newOrder
            },
        },
    },
    mounted() {
        this.$store.dispatch('customerPortal/fetchOrder', this.$route.params.id)
        this.$store.dispatch('orders/fetchDrivers')
        this.$store.dispatch('company/fetch')

        this.serviceRequest = this.order
    },
    methods: {
        triggerReport(type) {
            this.statementType = type
            this.$refs.reportsDialog.show()
        },
        cancel() {
            this.$router.push('/customer-portal/service-requests')
        },
        activateAccordion(active) {
            if (this.activeAccordion === active) {
                this.activeAccordion = false
            } else {
                this.activeAccordion = active
            }
        },
        cancelRating() {
            this.editMode = !this.editMode
            this.serviceRequest.feedback = null
        },
        onSubmit() {
            const path = 'customerPortal/updateOrder'
            this.$validator.validate().then(valid => {
                if (valid) {
                    if (this.serviceRequest.feedback < 1) {
                        return this.genericToast(
                            this.$translate('service_request'),
                            this.$translate('error'),
                            'danger',
                            this.$translate(`rating_required`)
                        )
                    }
                    this.loading = true
                    this.$store
                        .dispatch(path, this.serviceRequest)
                        .then(() => {
                            this.loading = false
                            this.genericToast(
                                this.$translate('service_request'),
                                this.$translate('updated'),
                                'success',
                                this.$translate(`service_request_rating_updated`)
                            )

                            this.$store.dispatch('customerPortal/fetchOrders')
                            this.editMode = false
                        })

                        .catch(error => {
                            console.error('Customer rating submit error', error)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
    },
}
</script>
<style></style>
